<template>
  <section class="pt-4 mb-4">
    <div class="container text-center">
      <div class="row">
        <div class="col-lg-6 text-center text-lg-left mb-4 pt-4">
          <h1 class="fw-600 h4">{{ $t("所有类别") }}</h1>
        </div>
        <div class="col-lg-6">
          <ul
            class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
          >
            <li class="breadcrumb-item opacity-50">
              <router-link class="text-reset" to="/"
                >{{ $t("首页") }}
              </router-link>
            </li>
            <li class="text-dark fw-600 breadcrumb-item">
              <a class="text-reset">"{{ $t("所有类别") }}"</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container">
      <div
        v-for="cate in cates"
        :key="cate.code"
        class="mb-3 bg-white shadow-sm rounded"
      >
        <div class="p-3 border-bottom fs-16 fw-600">
          <router-link
            :to="categoryUrl(cate)"
            class="text-reset"
            >{{ $t(cate.name) }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { getListCates } from "@/api/goods.js";

export default {
  data() {
    return { cates: [] };
  },
  methods: {
    async getCateList() {
      this.cates = (await getListCates()).data;
    },
  },
  created() {
    this.getCateList();
  },
};
</script>
